import { useAuthState } from "../../MainComponents/GlobalContext.jsx";
import useAxios from "../../MainComponents/Hooks/useAxios.jsx";
import Loader from "../../MainComponents/Loader.jsx";
import HelmetTags from "../../MainComponents/HelmetTags.jsx";

function HomePage() {
  const { userData } = useAuthState();

  const [postsDataSuccess, postsErrors, postsDataLoading] = useAxios(
    process.env.REACT_APP_STUDENT_POSTS_API,
    "GET",
    "GET",
  );

  if (postsDataLoading) {
    return <Loader />;
  }

  return (
    <section className="width pt-10">
      <HelmetTags title="Home | Mr.Mohamed Salama" />

      <div className="student-feed">
        <div className="student-feed__greeting">
          <h1>
            Hi, {userData?.student?.first_name} {userData?.student?.second_name}
          </h1>
          <span className="student-feed__wave" aria-hidden="true">
            👋
          </span>
        </div>

        {postsErrors && typeof postsErrors === "string" ? (
          <div className="student-feed__empty">
            <p>{postsErrors}</p>
          </div>
        ) : !postsDataSuccess?.data?.length ? (
          <div className="student-feed__empty">
            <p>No posts yet.</p>
          </div>
        ) : (
          <div className="dashboard-posts student-feed__list">
            {postsDataSuccess.data.map((post) => {
              const contentWrapper = document.createElement("div");
              contentWrapper.innerHTML = post?.content || "";

              if (
                contentWrapper.childNodes.length > 0 &&
                contentWrapper.firstChild.nodeType === 1
              ) {
                contentWrapper.removeChild(contentWrapper.firstChild);
              }

              return (
                <article
                  key={post?.id || post?.n}
                  className="dashboard-post-card"
                >
                  <header className="dashboard-post-card__header">
                    <div className="dashboard-post-card__meta">
                      <p className="dashboard-post-card__id">
                        Post #{post?.n}
                      </p>
                      <p className="dashboard-post-card__date">
                        {post?.created_at}
                      </p>
                    </div>
                  </header>

                  <div
                    className="dashboard-post-card__body"
                    dangerouslySetInnerHTML={{
                      __html: contentWrapper.innerHTML,
                    }}
                  />
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}

export default HomePage;
